<template>
  <div
    class="footer-row">
    <sButton
      v-if="back_btn"
      class="btn h7-text"
      :disabled="loading || back_disable || !!direction"
      icon="long-arrow"
      icon-class="s-svg-icon-rotate-90"
      :loading="loading || direction === 'back'"
      type="text"
      @click="chngeSteps(false)">
      {{ typeof back_btn == 'string' ? back_btn : $t('Common.Back') }}
    </sButton>
    <slot name="back"/>
    <slot name="central"/>
    <div class="pr-2">
      <v-row
        align="center"
        no-gutters>
        <slot name="next"/>
        <sTooltip
          v-if="next_btn"
          :border="false"
          :content="next_disable_tooltip"
          :disabled="!next_disable_tooltip"
          placement="bottom"
          type="white">
          <div>
            <sButton
              data-qa="footer-button-next"
              :disabled="loading || next_disable || !!direction"
              :loading="loading || direction === 'next'"
              @click="chngeSteps(true)">
              {{ typeof next_btn == 'string' ? next_btn : $t('Common.Next') }}
            </sButton>
          </div>
        </sTooltip>
      </v-row>
    </div>
  </div>
</template>
<script>
export default {
  name: 'componentFooter',
  data() {
    return {
      direction: null,
    }
  },
  props: {
    back_btn: [Boolean, String],
    next_btn: [Boolean, String],
    next_disable: Boolean,
    back_disable: Boolean,
    next_disable_tooltip: String,
    next: Function,
    back: Function,
    publish: Boolean,
    loading: {
      type: Boolean
    }
  },
  methods: {
    async chngeSteps(mode) {
      this.direction = mode ? 'next' : 'back'
      try {
        if (mode && this.next ) {
          await this.next()
        } else if ( !mode &&  this.back) {
          await this.back()
        }
      } catch (error) {
        this.$log_error(error)
      }
      this.direction = null
    }
  }
}
</script>
<style scoped>
.footer-row {
  display: contents;
  flex-wrap: wrap;
  flex: 1 1 auto;
  justify-content: space-between !important;
}
</style>
